export default "__VITE_ASSET__B$GAzKib__"